import { Svg, type Props as SvgProps } from './Svg'

export const IconCancel = (props: SvgProps) => (
	<Svg {...props} viewBox='0 0 24 24' fill='currentcolor' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M16.9031 5.68266C15.5479 4.62846 13.846 4 12 4C7.58878 4 4 7.58879 4 12C4 13.846 4.62846 15.5479 5.68265 16.9031L16.9031 5.68266ZM18.3173 7.09687L7.09686 18.3173C8.45206 19.3715 10.154 20 12 20C16.4112 20 20 16.4112 20 12C20 10.154 19.3715 8.45207 18.3173 7.09687ZM12 2C17.5229 2 22 6.47715 22 12C22 17.5228 17.5229 22 12 22C6.47717 22 2 17.5228 2 12C2 6.47715 6.47717 2 12 2Z'
		/>
	</Svg>
)
